// extracted by mini-css-extract-plugin
module.exports = {"svg":"_1g27S","rating":"_2bPli"};